/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 4 = Diesel
 *
 * 5 = Electric
 *
 * 6 = Hybrid
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
 */
export enum RequirementFuelType {
  Diesel = 4,
  Electric = 5,
  Hybrid = 6,
  Petrol = 10,
  Unleaded = 11,
}
